const state = {
  isProcessing: false
}

const getters = {
  isProcessing: state =>  state.isProcessing,
}

const mutations = {
  turnLoadingOn: state => state.isProcessing = true,
  turnLoadingOff: state => state.isProcessing = false,

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
